import React from "react";

const Preferences = () => {
    return (
        <div>
            <h1>Préférences</h1>
            <img src="./Images/travaux.gif" alt="Travaux en cours" />
        </div>
    );
};

export default Preferences;
